import { render, staticRenderFns } from "./Frameworks.vue?vue&type=template&id=0e067ad0"
import script from "./Frameworks.vue?vue&type=script&lang=js"
export * from "./Frameworks.vue?vue&type=script&lang=js"
import style0 from "./Frameworks.vue?vue&type=style&index=0&id=0e067ad0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports